export default __webpack_public_path__ + "static/Flowers_White-ff956268b923f3362a235f7973a70b85.jpg";